import React from 'react';
import SkeletonBlock from './SkeletonBlock';

const DEFAULT_COLUMNS = [220, 160, 140, 120, 100];

export default function TableSkeleton({
  rows = 8,
  columns = DEFAULT_COLUMNS,
  showHeader = true,
  label = 'Loading table',
  className = '',
}) {
  return (
    <div className={`sk-table-wrap ${className}`.trim()} role="status" aria-busy="true" aria-label={label}>
      <table className="sk-table">
        {showHeader ? (
          <thead className="sk-table__head">
            <tr>
              {columns.map((width, index) => (
                <th key={`h-${index}`}>
                  <SkeletonBlock width={Math.round(width * 0.55)} height={11} />
                </th>
              ))}
            </tr>
          </thead>
        ) : null}
        <tbody>
          {Array.from({ length: rows }, (_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((width, colIndex) => (
                <td key={`${rowIndex}-${colIndex}`}>
                  <SkeletonBlock
                    width={colIndex === 0 ? width : Math.max(64, width - (rowIndex % 3) * 12)}
                    height={12}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { DEFAULT_COLUMNS as TABLE_SKELETON_COLUMNS };
